import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as PXBColors from '@brightlayer-ui/colors';
const manageAlarmsStyle = makeStyles(() =>
    createStyles({
      
        padding8: { padding: 8 },
        marginRight8: { marginRight: 8 },
        padding16: { padding: 16 },
        marginpadding8: { margin:8,padding: 8 },
        paddingBottom8: { paddingBottom: 8 },


        avatar: {
            backgroundColor: PXBColors.blue[400],
            color: PXBColors.white[500],
        },
        equalSpacing: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        iconRightEnd: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        rightSideButtonPosition: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px',
        },
        heightAuto: {
            height: 'auto',
        },
        paddingTextbox: {
            padding: '16px 8px',
        },
        Paper: {
            marginTop: '5px',
            overflow: 'auto',
            width: '100%',
            height:'100%',
            '&::-webkit-scrollbar': {
                width: '1px',
                borderRadius: '1px',
            },
            '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 5px grey',
                borderRadius: '1px',
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'grey',
                borderRadius: '1px',
            }
        },
        drawerPaper: {
            marginTop: "50px",
            overflow:"hidden"
          }
    })
);

export default manageAlarmsStyle;
